import React from 'react'
import { Link } from 'react-router-dom'
import './needHelp.scss'

const NeedHelp = () => {
    return (
        <div className="need_help">
            <span className='sm'>Need help?
                &nbsp;<a href='https://lumimatrimony.com/index.html' target="_blank" rel="noopener noreferrer">Contact Us</a>
            </span>
            <div className="bottom">
                <a href='/privacy' target="_blank" rel="noopener noreferrer" className='sm'>Privacy</a>
                <span>&</span>
                <a href='/terms' target="_blank" rel="noopener noreferrer" className='sm'>Terms</a>
            </div>
        </div>

    )
}

export default NeedHelp